export default "__VITE_ASSET__DhVeLtro__"